import { render, staticRenderFns } from "./TaskActive.vue?vue&type=template&id=0fb26a7e&"
import script from "./TaskActive.vue?vue&type=script&lang=js&"
export * from "./TaskActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports